var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orderType && _vm.restaurantId
    ? _c(
        "div",
        { class: _vm.$style.dropdown, attrs: { "offset-y": "" } },
        [
          _c(
            "button",
            {
              class: _vm.$style.headerStore,
              on: { click: _vm.clickRestaurantHandler }
            },
            [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.headerStoreIcon,
                attrs: { symbol: "store-icon" }
              }),
              _vm._v(" "),
              _c("span", { class: _vm.$style.headerText }, [
                _c("span", { class: _vm.$style.headerStoreName }, [
                  _vm._v(_vm._s(_vm.restTitle))
                ]),
                _vm._v("\n      " + _vm._s(_vm.orderTypeTitle) + "\n    ")
              ]),
              _vm._v(" "),
              _c("div", { class: _vm.$style.headerDownWrapper }, [
                _c("svg", {
                  directives: [{ name: "svg", rawName: "v-svg" }],
                  class: _vm.$style.headerDownIcon,
                  attrs: { symbol: "chevron-down" }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "CommonModal",
            {
              attrs: {
                display: _vm.showAbandonModal,
                "always-modal": true,
                width: "480",
                type: "AppendModal",
                title: "Abandon Boss Creation?",
                name: "linkSent"
              },
              on: { toggleModal: _vm.cancelHandler }
            },
            [
              _c("ConfirmModalContent", {
                attrs: {
                  message: "Are you sure you want to abandon this creation?",
                  "confirm-text": "Yes, ABANDON",
                  "cancel-text": "NO"
                },
                on: { confirm: _vm.confirmHandler, cancel: _vm.cancelHandler }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "CommonModal",
            {
              attrs: {
                display: _vm.showCancelOrderModal,
                "always-modal": true,
                width: "480",
                type: "AppendModal",
                title: "Cancel Order?",
                name: "cartOrderCancel"
              },
              on: { toggleModal: _vm.cancelOrderCancellingHandler }
            },
            [
              _c("ConfirmModalContent", {
                attrs: {
                  message: "Are you sure you want to cancel your entire order?",
                  "confirm-text": "YES, CANCEL",
                  "cancel-text": "NO"
                },
                on: {
                  confirm: _vm.cancelOrder,
                  cancel: _vm.cancelOrderCancellingHandler
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/desktop/components/DesktopRestaurantButton.vue?vue&type=template&id=7d5917b9&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&
// module id = null
// module chunks = 